import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Box, Link } from "@mui/material";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, isDark = false }, ref) => {

    const logo = (
        <Box
            component="img"
            ref={ref}
            src={isDark ? "/logo-dark.svg" : "/logo.svg"}
            alt="Logo"
            sx={{
                width: 194,
                height: 48,
                display: "inline-block",
                cursor: "pointer",
                ...sx,
            }}
        />

    );

    if (disabledLink) {
        return logo;
    }

    return (
        <Link component={RouterLink} to="/" sx={{ display: "contents" }}>
            {logo}
        </Link>
    );
});

Logo.propTypes = {
    sx: PropTypes.object,
    disabledLink: PropTypes.bool,
};

export default Logo;
